module.exports = __webpack_public_path__ + "fonts/iOSActive_60x60.7e55f20d98471fd7dd64c4ba4ceef2a1.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/iOSActive_60x60.png
// module id = 740
// module chunks = 9